/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import './servicios-incluidos.css';

class ServiciosIncluidos extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const iconos = {
      vuelo: 'fa fa-plane',
      asistencia: 'fa fa-medkit',
      traslados: 'fa fa-car',
      hotel: 'fa fa-bed',
      excursiones: ' ',
      auto: 'fa fa-car',
      guia: 'fa fa-map',
    };

    const services = this.props.iconos.reverse();

    const servicios = services.map((item, index) => {
      return (
        <div key={index} className='col-lg-2 col-md-3 col-sm-12'>
          <div className='contenedor icono-servicio  text-center'>
            <span className={`color-dinamico icono fa ${iconos[item]}`} />
            <span className='descripcion'>{item.charAt(0).toUpperCase() + item.slice(1)}</span>
          </div>
        </div>
      );
    });

    return this.props.iconos.length > 0
      ? (
        <div className='seccion'>
          <h3 className='titulo-seccion'>Servicios Incluidos</h3>
          <div className='panel panel-default custom bordeado itinerario servicios-panel'>
            <div className='panel-body'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='descripcion'>
                    {servicios}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
      : (<div />);
  }

}

export default ServiciosIncluidos;
